import { platforms } from '@/mocks/data';

export default function PlatformSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            合作平台推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            精选信誉平台，彩金丰富，资金安全，提款无忧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {platforms.map((platform) => (
            <div
              key={platform.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-accent-600 text-lg"></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{platform.name}</h3>
                  <div className="flex items-center gap-1">
                    <div className="flex items-center">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-fill text-xs ${
                            i < Math.floor(platform.rating) ? 'text-accent-500' : 'text-background-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-xs text-foreground-500 font-medium">{platform.rating}</span>
                  </div>
                </div>
              </div>

              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {platform.description}
              </p>

              <div className="flex flex-wrap gap-1.5">
                {platform.features.map((f) => (
                  <span
                    key={f}
                    className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full"
                  >
                    {f}
                  </span>
                ))}
              </div>

              <p className="text-xs text-foreground-500 mt-3">
                {platform.reviewCount.toLocaleString()}条评价
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}